import React from "react";
import slider1 from "../../assets/images/item3.png";
import slider2 from "../../assets/images/item1.png";
import slider3 from "../../assets/images/item2.png";

const slides = [
  {
    id: 1,
    image: slider2,
    title: "Women Collection 2018",
    heading: "NEW SEASON",
    link: "product.html",
  },
  {
    id: 2,
    image: slider1,
    title: "Men New-Season",
    heading: "Jackets & Coats",
    link: "product.html",
  },
  {
    id: 3,
    image: slider3,
    title: "Men Collection 2018",
    heading: "New arrivals",
    link: "product.html",
  },
];

const HomeSlider = () => {
  return (
    <section className="section-slide">
      <div id="mainCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {/* {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`carousel-item ${index === 0 ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
              }}
            >

            </div>
          ))} */}
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  aspectRatio: window.innerWidth < 768 ? "1 / 1" : "1860 / 950",
                  width: "100%",
                }}
                className="d-block w-100"
              />
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#mainCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#mainCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>

        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#mainCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeSlider;
